// Style bundle
import '../../sass/style.scss';

import { appConfig as $config } from './app.config';

import { Common } from './modules/Common';
import { UI } from './modules/UI';
import { SortFilter } from './modules/SortFilter';
import { User } from './modules/User';
import { App } from './modules/App';
import { Router } from './modules/Router';
import { Ministu } from './modules/Ministu';
import { ProductApprovalShort } from './modules/ProductApprovalShort';
import { ProductApproval } from './modules/ProductApproval';
import { ProductApprovalFull } from './modules/ProductApprovalFull';
import { MasterProductData } from './modules/MasterProductData';
import { CloudUploader } from './modules/CloudUploader';
import { WS } from './modules/WS';
import { ItemCardNotice } from './modules/ItemCardNotice';
import { ReactHandler } from './modules/ReactHandler';
import { ProductInfo } from './modules/ProductInfo';
import { importSalesOrder } from './pages/Orders/importSalesOrder';
import { ArtworksBulkImport } from './modules/ArtworksBulkImport';
import { ApprovalRejection } from './modules/ApprovalRejection';

/*
 ** App Pages
 */
import { Login } from './pages/Login';
import { notFound } from './pages/404';
import { Main } from './pages/Main';
import { Artworks } from './pages/Artworks';
import { Blanks } from './pages/Blanks';
import { BlankUpload } from './pages/BlankUpload';
import { Prelisting } from './pages/Prelisting';
import { Listings } from './pages/Listings';
import { Trims } from './pages/Trims';
import { Transactions } from './pages/Transactions';
import { Settings } from './pages/Settings';
import { SettingsUser } from './pages/SettingsUser';
import { Legal } from './pages/Legal';
import { Stamps } from './pages/Stamps';
import { CustomerAccount } from './pages/CustomerAccount';
import { Orders } from './pages/Orders';
//import {Fulfillment}        from './pages/Fulfillment';
//import {Briefs}             from './pages/Briefs';
//import {StyleGuides}        from './pages/StyleGuides';

let index = (function () {
  let isWraped = false; // - Page`s Header & Menu

  let init = () => {
    // REACT App
    if ($config.APP_REACT) {
      window.addEventListener('pagerender:complete', reactInit);
    } else {
      App.init();
      // routing();
    }
  };

  let reactInit = () => {
    App.init();
    // routing();
    window.removeEventListener('pagerender:complete', reactInit);
  };

  let start = (
    callback = () => {}, // - Default page
    // callback = Blanks.init,  // - Default page
    params = {}, // - Params from routing
    query = '' // - Query from routing
  ) => {
    if (!User.isUser() && !$config.APP_REACT) {
      return $router.navigate('/login');
    }

    // Set And Reinit Query params
    Common.restoreQuery();

    if (isWraped) {
      callback(params, query);
    } else {
      UI.blockPage();

      Main.wrapper({}).then(() => {
        isWraped = true;
        UI.unblockPage();
        callback(params, query);
      });
    }
  };

  let initRouting = () => {
    let $router = Router.init();
    $router
      .on({
        /*'/briefs': (params, query) => {
          start(Briefs.init, params, query);
        },
        '/briefs/:id/:action': (params, query) => {
          start(Briefs.init, params, query);
        },

        '/styleGuides': (params, query) => {
          start(StyleGuides.init, params, query);
        },
        '/styleGuides/:id/:action': (params, query) => {
          start(StyleGuides.init, params, query);
        },

        '/fulfillment': (params, query) => {
          start(Fulfillment.init);
        },
        '/fulfillment/:action': (params, query) => {
          start(Fulfillment.init, params, query);
        },
        */

        '/blanks': (params, query) => {
          // start(Blanks.init, params, query);
        },
        '/blanks/:id/:action': (params, query) => {
          // start(Blanks.init, params, query);
        },

        '/artworks': (params, query) => {
          // start(Artworks.init, params, query);
        },
        '/artworks/:id/:action': (params, query) => {
          // start(Artworks.init, params, query);
        },

        '/prelistings': (params, query) => {
          // start(Prelisting.init, params, query);
        },
        '/prelistings/:id/:action': (params, query) => {
          // start(Prelisting.init, params, query);
        },

        '/listings': (params, query) => {
          // start(Listings.init, params, query);
        },
        '/listings/:id/:action': (params, query) => {
          // start(Listings.init, params, query);
        },

        '/trims': (params, query) => {
          // start(Trims.init, params, query);
        },
        '/trims/:id/:action': (params, query) => {
          // start(Trims.init, params, query);
        },

        '/stamps': (params, query) => {
          // start(Stamps.init, params, query);
        },
        '/stamps/:id/:action': (params, query) => {
          // start(Stamps.init, params, query);
        },

        '/transactions': (params, query) => {
          // start(Transactions.init);
        },

        '/orders': (params, query) => {
          // start(Orders.init);
        },
        '/orders/:id/:action': (params, query) => {
          // start(Orders.init, params, query);
        },

        '/settings': () => {
          // if (User.isAdminFantec()) {
          //   start(Settings.init);
          // }
          // else {
          //   UI.handlerPageAccessDenied();
          // }
        },
        '/settings/:id/:action': (params, query) => {
          // if (User.isAdminFantec()) {
          //   start(Settings.init, params, query);
          // }
          // else {
          //   UI.handlerPageAccessDenied();
          // }
        },

        // '/legal': (params, query) => {
        //   start(Legal.init);
        // },
        // '/legal/:action': (params, query) => {
        //   start(Legal.init, params, query);
        // },

        '/customerAccount': (params, query) => {
          // start(CustomerAccount.init, params, query);
        },
        '/customerAccount/:id/:action': (params, query) => {
          // start(CustomerAccount.init, params, query);
        },
        '/customerAccount/:action': (params, query) => {
          // start(CustomerAccount.init, params, query);
        },

        '/bom-import': () => {
          // no remove
        },
        '/sku-catalog': () => {
          // no remove
        },
        '/audit': () => {
          // no remove
        },
        '/legal': () => {
          // no remove
        },
        '/legal/:id': () => {
          // no remove
        }

        // '/login': () => {
        //   isWraped = false;
        //   if (!User.isUser()) Login.init();
        //   else $router.navigate('/');
        // }
      })
      .on(function (query) {
        if ($config.APP_REACT) {
          return false;
        }
        $router.forceNavigate('/' + $config.routing.startpage, true);
      })
      .notFound(function () {
        isWraped = false;
        notFound.page();
      })
      .resolve();
  };

  return {
    init,
    initRouting
  };
})();

export {
  importSalesOrder,
  CloudUploader,
  App,
  index,
  Common,
  Artworks,
  Ministu,
  ProductApprovalShort,
  ProductApproval,
  ProductApprovalFull,
  MasterProductData,
  Blanks,
  BlankUpload,
  CustomerAccount,
  Listings,
  Prelisting,
  Settings,
  Stamps,
  Trims,
  Orders,
  User,
  WS,
  ReactHandler,
  Transactions,
  Router,
  UI,
  SortFilter,
  ItemCardNotice,
  SettingsUser,
  ProductInfo,
  ArtworksBulkImport,
  ApprovalRejection
};
